import React from "react";
import { Button } from "react-bootstrap";
import './Yellow_Btn.css'

const Yellow_Btn = ({ btnText, onClick, className = "" }) => {
    return (
        <section className="Yellow_Btn_holder">
            <Button 
                className={`Yellow_Btn ${className}`} 
                onClick={onClick}
            >
                {btnText}
            </Button>
        </section>
    )
}

export default Yellow_Btn;
